/**
 * src/connects/chat-room-settings-page.js
 */

import { translate } from 'react-i18next'
import combineHOC from '../helpers/combine-hoc'

export default combineHOC(
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/chat-room-settings-page.js